define(['jquery', 'bootstrap'], function (jQuery) {
    var returnObj = {};
    /**
     * Change icon from event starter action for collapse
     */
    returnObj.collapsIconChange = function (target) {
        var currentTargetClass = target.classList[0];

        /**
         * exsist data-class than change the icon
         */
        var $glyphiconElement = jQuery('[data-bs-target=".' + currentTargetClass + '"] span[data-class]');
        if (!!$glyphiconElement) {
            var $glyphiconChange = $glyphiconElement.attr('data-class');
            var glyphiconClass = $glyphiconElement.attr('class');
            $glyphiconElement.attr('data-class', glyphiconClass);

            $glyphiconElement.removeClass().addClass($glyphiconChange);
            $glyphiconElement.parent().parent().children('.pop-arrow').toggle();
        }
    }


    jQuery('.collapse').on('shown.bs.collapse', function (e) {
        returnObj.collapsIconChange(e.currentTarget);
    });

    jQuery('.collapse').on('hidden.bs.collapse', function (e) {
        returnObj.collapsIconChange(e.currentTarget);
    });

    return returnObj;
});
